export const ProfilePictureType = {
    driver: 'Driver',
    company: 'Company',
};
